import { Instance as TinyColor } from 'tinycolor2'
import React, { useCallback, useRef, useState } from 'react'
import useStyles from './styles'
import { Button, Stack } from '@mui/material'
import Edit from '../../assets/icons/drawingTools/edit'
import ColorPopover from './colorPopover/colorPopover'
import tinycolor from 'tinycolor2'
import { useDispatch } from 'react-redux'
import commonActions from '../../actions/common.actions'
import { selectCustomColors } from '../../selectors/common'
import { useSelector } from 'react-redux'

export type ColorSelectorProps = {
    color: string,
    opacity: number,
    swatchSize?: number,
    compact?: boolean,
    showOnlySwatch?: boolean,
    onColorChange: (color: string, transparency: number) => void
}

const ColorSelector: React.FC<ColorSelectorProps> = ({ color, opacity, onColorChange, showOnlySwatch = false, compact = false }) => {
    const colorValue = tinycolor(color)
    colorValue.setAlpha(opacity)
    const { classes, cx } = useStyles({color: colorValue, showOnlySwatch});
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)
    const popoverAnchor = useRef<HTMLDivElement>(null);
    const customColors = useSelector(selectCustomColors)

    const onAddCustomColor = useCallback((newColor: TinyColor) => {
        commonActions.addCustomColor(dispatch, newColor.toRgbString())
    }, [])
    return <div className={classes.container}>
        <Button
            className={cx(classes.swatch, {
                [classes.compact]: compact
            })}
            size={compact ? 'medium' : 'large'}
            color="inherit"
            // ref={popoverAnchor}
            onClick={() => {
                if (anchorEl) {
                    setAnchorEl(null);
                    return;
                }
                popoverAnchor.current && setAnchorEl(popoverAnchor.current)
            }}>
            <Stack alignItems={'center'} justifyContent={'center'} gap={0.5}>
                {!showOnlySwatch && <Edit />}
                <div className={classes.swatchBackground} />
            </Stack>
            {!compact && <span style={{ marginLeft: '8px' }}
                               className={classes.value}>{color} ({(opacity * 100).toFixed(2)}%)</span>}
            <div style={{display: "hidden"}} ref={popoverAnchor}></div>
        </Button>
        
        {anchorEl && <ColorPopover
                            anchorEl={anchorEl} value={colorValue}
                            onChange={(newValue) => {
                                onColorChange(newValue.toHexString(), newValue.getAlpha())
                            }}
                            onClose={() => setAnchorEl(null)}
                            onAddSwatch={onAddCustomColor}
                            recentSwatches={customColors}/>}
        {/* <MuiColorInput
            value={colorInput}
            ref={ref}
            className={classes.colorInput}
            onChange={(value, colors) => {
                const c = new TinyColor(colors.rgb)
                onColorChange(c.toHexString(), c.getAlpha())
            }}
        /> */}
    </div>

}


export default ColorSelector